<template>
  <div class="standard_item">
    <el-form-item :label="displayLabel" :prop="`${tableName}.${groupName},${item.key}`" class="standard-readonly-item">
        <span v-if="item.code === 'DELIVERY_TERMS'" class="readonly-text">{{DELIVERY_TERMS}}</span>
        <span v-else-if="item.code === 'SYS_MST_PORT_AND_PLACE'" class="readonly-text">{{portAndPlace}}</span>
        <span v-else-if="isQuantity" class="value" :class="item.key">{{formatQuantity}}</span>
        <span v-else-if="isCurrency" class="value" :class="item.key">{{formatCurrency}}</span>
        <span v-else-if="item.code === 'PAYMENT_TERMS'" class="readonly-text">{{PAYMENT_TERMS}}</span>
        <span v-else-if="item.code === 'BOOKING_TYPE'" class="readonly-text">{{BOOKING_TYPE}}</span>
        <span v-else-if="item.code === 'SYS_MST_CONTAINER_TYPE'" class="readonly-text">{{SYS_MST_CONTAINER_TYPE}}</span>
        <span v-else-if="item.code === 'SYS_MST_PACKAGE_TYPE'" class="readonly-text">{{SYS_MST_PACKAGE_TYPE}}</span>
        <span v-else-if="item.code === 'TYPE_OF_MOVE'" class="readonly-text">{{TYPE_OF_MOVE}}</span>
        <span v-else-if="item.code === 'HAZARDOUS_FLAG'" class="readonly-text">{{HAZARDOUS_FLAG}}</span>
        <span v-else-if="item.code === 'TRANSPORTATION'" class="readonly-text">{{TRANSPORTATION}}</span>
        <span v-else-if="item.code === 'TYPE_OF_SERVICE_FCL_LCL'" class="readonly-text">{{TYPE_OF_SERVICE_FCL_LCL}}</span>
        <span v-else-if="item.code === 'CARGO_TRACKING_FLG'" class="readonly-text">{{CARGO_TRACKING_FLG}}</span>
        <span v-else-if="item.code === 'CO_REQUIRED_FLAG'" class="readonly-text">{{CO_REQUIRED_FLAG}}</span>
        <span v-else style="color: #111;" class ="readonly-text">{{ displayValue }}</span>
    </el-form-item>
  </div>
</template>

<script>
import _ from 'lodash';
import {LANGUAGE_SETTING,PAYMENT_TERMS_VARIABLES,TRANSPORTATION_SERVICE_LEVEL,HAZARDOUS_FLAG_VARIABLES,TRANSPORTATION_VARIABLES,TYPE_OF_SERVICE_FCL_LCL_VARIABLES,CARGO_TRACKING_FLG_VARIABLES,CO_REQUIRED_FLAG_VARIABLES,DELIVERY_TERMS_VARIABLES, BOOKING_TYPE_VARIABLES, TYPE_OF_MOVE_VARIABLES} from 'lib-tw-common';
import { formatQuantity, formatCurrency } from '@/utils/searchUtil.js';

export default ({
  name: 'TwProcessGroupListItemStandard',
  props: {
    item: Object,
    tableName: String,
    groupName: String,
    value: Object,
    isEditMode: Boolean,
  },
  inject: ['s'],
  data () {
    return {
      PAYMENT_TERMS_VARIABLES,
      HAZARDOUS_FLAG_VARIABLES,
      TRANSPORTATION_SERVICE_LEVEL,
      TRANSPORTATION_VARIABLES,
      TYPE_OF_SERVICE_FCL_LCL_VARIABLES,
      CARGO_TRACKING_FLG_VARIABLES,
      CO_REQUIRED_FLAG_VARIABLES,
      DELIVERY_TERMS_VARIABLES,
    }
  },
  computed: {
    model() {  
      if (this.isEditMode) {
        return _.get(this.s.cloneItems, `${this.tableName}.${this.groupName}.${this.item.key}`);
      }
      return _.get(this.s.res, `${this.tableName}.${this.groupName}.${this.item.key}`);
    },
    displayValue() {
      const isContainerNo = this.tableName === 'linkageTransportation' && this.groupName === 'containerInfoGrp' && this.item?.key === 'containerNo'
      const val = isContainerNo ? this.value?.linkageTransportation?.containerInfoGrp?.arrayContainerSeals?.[0]?.containerNo : this.value?.[this.tableName]?.[this.groupName]?.[this.item.key];
      if(val === null || val === undefined || val === '') return '';
      if(this.item.inputType === 'date' && typeof val === 'string') {
        return val.slice(0, 10);
      }
      return val;
    },
    displayLabel() {
      const isEngLish = this.$store.state.language === LANGUAGE_SETTING.ENGLISH;
      return isEngLish ? this.item.label : this.item.jpLabel || this.item.label;
    },
    DELIVERY_TERMS() {
      const model = this.item.unitTarget ? _.get(this.s.res, this.item.unitTarget): this.model;
      return _.get(_.find(DELIVERY_TERMS_VARIABLES, {code: model}), 'label') || '';
    },
    portAndPlace() {
      return this.model;
    },
    PAYMENT_TERMS() {
      const model = this.item.unitTarget ? _.get(this.s.res, this.item.unitTarget) : this.model;
      return _.get(_.find(PAYMENT_TERMS_VARIABLES, {code: model}), 'label') || '';
    },
    CARGO_TRACKING_FLG() {
      const model = this.item.unitTarget ? _.get(this.s.res, this.item.unitTarget): this.model;
      return _.get(_.find(CARGO_TRACKING_FLG_VARIABLES, {code: model}), 'label') || '';
    },
    HAZARDOUS_FLAG() {
      const model = this.item.unitTarget ? _.get(this.s.res, this.item.unitTarget): this.model;
      return _.get(_.find(HAZARDOUS_FLAG_VARIABLES, {code: model}), 'label') || '';
    },
    TRANSPORTATION() {
      return _.get(_.find(TRANSPORTATION_VARIABLES, {code: this.model}), 'label') || '';
    },
    BOOKING_TYPE() {
      return _.get(_.find(BOOKING_TYPE_VARIABLES, {code: this.model}), 'label') || '';
    },
    TYPE_OF_MOVE() {
      return _.get(_.find(TYPE_OF_MOVE_VARIABLES, {code: this.model}), 'label') || '';
    },
    SYS_MST_CONTAINER_TYPE() {
      const target = this.item.unitTarget.split('.');
      const unitTarget = target.length ? `${target[0]}.${target[1]}.${target[2]}` : '';
      return _.get(_.find(this.$store.getters.getSysMstContainerType, {type: this.model, size: String(_.get(this.s.res, unitTarget))}), 'description') || '';
    },
    SYS_MST_PACKAGE_TYPE() {
      return _.isString(this.model) ? this.model.split(',')[0] : null;
    },
    TYPE_OF_SERVICE_FCL_LCL() {
      return _.get(_.find(TYPE_OF_SERVICE_FCL_LCL_VARIABLES, {code: this.model}), 'label') || '';
    },
    CO_REQUIRED_FLAG() {
      const model = this.item.unitTarget ? _.get(this.s.res, this.item.unitTarget): this.model;
      return _.get(_.find(CO_REQUIRED_FLAG_VARIABLES, {code: model}), 'label') || '';
    },
    isCurrency() {
      return ['currencyRef', 'currency', 'totalAmount', 'noCommercialValueAmount'].includes(this.item.inputType);
    },
    isQuantity() {
      return ['quantity', 'totalQuantity', 'totalNetWeight', 'totalGrossWeight', 'totalMeasurement', 'chargeableWeight', 'estimatedTotalGrossWeight', 'estimatedTotalMeasurement'].includes(this.item.inputType);
    },
    formatQuantity() {
      return formatQuantity(this.model, _.get(this.s.res, this.item.unitTarget), this.item.inputType === 'totalMeasurement' ? 6 : undefined);
    },
    formatCurrency() {
      const currencyUnit = _.get(this.s.res, this.item.unitTarget);
      const currencyId = _.get(_.find(this.SYS_MST_CURRENCY, {symbol: currencyUnit}), 'alphabeticCode');
      const currency = this.$store.getters.getCurrency(currencyId);
      if (currency) {
        return formatCurrency(this.model, currencyUnit, currency.minorUnit);
      }
      return formatCurrency(this.model, currencyUnit);
    },
  },
});
</script>

<style lang="scss" scoped>
  .standard-readonly-item .readonly-text,
  .standard-readonly-item .value {
    white-space: pre-wrap;
    word-break: break-word;
    user-select: text;
    cursor: text;
  }
</style>
